import { FC, useCallback, useContext, useState } from "react";
import { useNavigate, useSearchParams } from "react-router";

import { Button, Icon, Panel } from "capitalrx-components-2.0/lib/general";
import { Shelf, Stack } from "capitalrx-components-2.0/lib/layout";
import { Bold, Heading, Paragraph, Subheading } from "capitalrx-components-2.0/lib/typography";

import { getThemeButton, getThemeURL } from "@/utils";
import { ThemeSelectorContext } from "@/context";


const CaseDraftSuccess: FC = () => {
  const navigate = useNavigate();
  const { primary_color } = useContext(ThemeSelectorContext);
  const [urlParams] = useSearchParams();
  const [accessCode] = useState(() => urlParams.get("access_code"));

  const goToCaseDraftCreate = useCallback(() => {
    const params = {};
    const encodedParams = new URLSearchParams();
    for (const key in params) {
      if (params[key]) {
        encodedParams.append(key, params[key]);
      }
    }
    navigate(`${getThemeURL("PA_CREATE")}?${encodedParams.toString()}`);
  }, [navigate]);

  return (
      <Stack alignment="center" spacing="large">
        <Stack alignment="center" spacing="small">
          <Icon name="check-circle" color="green" />
          <Heading>
            <Paragraph>Case Draft Successfully Sent</Paragraph>
          </Heading>
        </Stack>
        <Panel appearance="secondary">
          <Subheading>
            <Shelf spacing="mini">
              <Paragraph>Access Code: </Paragraph>
              <Bold>{ accessCode }</Bold>
            </Shelf>
          </Subheading>
        </Panel>
        <Button appearance={getThemeButton("secondary", primary_color)}
          onClick={goToCaseDraftCreate}
          testId="test__new_case_link"
        >
            Start A New Case
        </Button>
      </Stack>
  );
};

export default CaseDraftSuccess;
